import { render, staticRenderFns } from "./SummaryPageDetail.vue?vue&type=template&id=e2801024&scoped=true"
import script from "./SummaryPageDetail.vue?vue&type=script&lang=js"
export * from "./SummaryPageDetail.vue?vue&type=script&lang=js"
import style0 from "./SummaryPageDetail.vue?vue&type=style&index=0&id=e2801024&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2801024",
  null
  
)

export default component.exports